export function getAllActivityLogs(axiosPrivate: any) {
  return axiosPrivate.get('/activity-logs')
}
